import { gql } from '@apollo/client';

export const CONFIGS = gql`
  query Configs {
    configs {
      styling {
        contentTextColor
        customCss
        formFieldPlaceholderColor
        formFieldTextColor
        labelTextColor
        pageBackgroundColor
        primaryButtonColor
        primaryButtonTextColor
        secondaryButtonColor
        secondaryButtonTextColor
        sidebarBackgroundColor
        titleTextColor
        widgetBackgroundColor
      }
    }
  }
`;

export const PARTNER_CONFIG = gql`
  query PartnerConfig($domain: String!) {
    partnerConfig(domain: $domain)
  }
`;
